module.exports = __webpack_public_path__ + "img/gal-3.628f87ae.jpeg";